import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faXTwitter,
	faYoutube,
	faDiscord,
} from '@fortawesome/free-brands-svg-icons'
import { useInView } from 'react-intersection-observer'

function SocialMedia() {
	var steamID = '3423700' // 3423700 on prod, 1841660 on stg

	const { ref: h2Ref, inView: h2InView } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	})

	const { ref: socialRef, inView: socialInView } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	})

	const { ref: steamRef, inView: steamInView } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	})

	return (
		<div className="flex flex-col w-full items-center justify-center gap-6 text-white p-6 space-y-8 z-10 overflow-visible">
			{/* Title */}
			<h2
				ref={h2Ref}
				className={`text-2xl md:text-4xl font-bold tiny5 text-center ${
					h2InView ? 'animate-title' : 'opacity-0 visibility-hidden'
				}`}
			>
				JOIN THE COMMUNITY
			</h2>
			{/* Social Section */}
			<div
				ref={socialRef}
				className={`flex flex-col items-center w-full space-y-6 max-w-lg ${
					socialInView ? 'animate-from-left' : 'opacity-0'
				}`}
			>
				{/* Social Media Bubbles */}
				<div className="flex space-x-4 justify-center">
					<a
						href="https://x.com/Pl4no_B"
						target="_blank"
						rel="noopener noreferrer"
						className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center hover:bg-slate-200"
					>
						<FontAwesomeIcon
							icon={faXTwitter}
							className="text-black text-xl md:text-2xl"
						/>
					</a>
					<a
						href="https://www.youtube.com/@Pl4no-B"
						target="_blank"
						rel="noopener noreferrer"
						className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center hover:bg-slate-200"
					>
						<FontAwesomeIcon
							icon={faYoutube}
							className="text-black text-xl md:text-2xl"
						/>
					</a>
					<a
						href="https://discord.gg/Wjaf2sYHXz"
						target="_blank"
						rel="noopener noreferrer"
						className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-full flex items-center justify-center hover:bg-slate-200"
					>
						<FontAwesomeIcon
							icon={faDiscord}
							className="text-black text-xl md:text-2xl"
						/>
					</a>
				</div>

				{/* Newsletter Section */}
				<div className="w-full">
					<p className="text-sm md:text-lg quicksand text-center">
						Join the newsletter to get updates!
					</p>
					<iframe
						title="Newsletter Signup"
						id="beehiiv-embed"
						src="https://embeds.beehiiv.com/500a4bfb-d3a8-4d9f-a8fd-d4dc012c6cab?slim=true"
						data-test-id="beehiiv-embed"
						height="52"
						className="w-full rounded-lg mt-4"
					></iframe>
				</div>
			</div>
			{/* Steam Section */}
			<div
				ref={steamRef}
				className={`w-[120%] max-w-lg overflow-visible ${
					steamInView ? 'animate-from-right' : 'opacity-0'
				}`}
			>
				<iframe
					id="steam-widget"
					title="Steam Widget"
					src={`https://store.steampowered.com/widget/${steamID}/`}
					width="120%"
					height="120%"
					loading="lazy"
					className="w-[120%] ml-[-10%] scale-[80%] md:scale-100 overflow-visible"
				></iframe>
				{/* Responsive Steam Widget */}
				<div className="w-full h-16" />
			</div>
		</div>
	)
}

export default SocialMedia
